import React, { FC } from 'react'
import { Fab as MuiFab, FabProps } from 'transfix-ui/core'

export interface IFabProps extends FabProps {
  /**
   * Always include an aria-label for accessibility
   */
  'aria-label': string
}

/**
 * @name Fab
 * @see https://material-ui.com/api/fab/
 * @description "Floating action button", optimized for mobile screens
 * @example <Fab onClick={clickHandler}><Add /></Fab>
 */
export const Fab: FC<IFabProps> = props => {
  return <MuiFab {...props} />
}

export default Fab
